module.exports = __webpack_public_path__ + "static/media/middle-left-2.91444e08.png";